import React from "react";

interface DataLoadingIndicatorProps {
  percentage?: number;
}

export const DataLoadingIndicator: React.FC<DataLoadingIndicatorProps> = ({
  percentage = 0,
}) => {
  const radius = 12;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="content-stretch flex gap-[6px] items-center relative shrink-0 w-[67px]">
      <div className="relative shrink-0 size-[28px]">
        <svg
          className="block size-full -rotate-90"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 28 28"
        >
          {/* Background circle */}
          <circle
            cx="14"
            cy="14"
            r={radius}
            stroke="#D8D8D8"
            strokeWidth="2"
            fill="none"
            opacity="0.2"
          />
          {/* Progress circle */}
          <circle
            cx="14"
            cy="14"
            r={radius}
            stroke="#FB6A07"
            strokeWidth="2"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="flex flex-col font-medium h-[28px] justify-center leading-[0] not-italic relative shrink-0 text-[#979797] text-[14px] w-[33px]">
        <p className="leading-[normal]">{percentage}%</p>
      </div>
    </div>
  );
};
